import Query from './Query.vue'
import Tablee from './Table.vue'
export * from './Query.vue'
export * from './Table.vue'

export class VQuery extends Query {}
export class VTable extends Tablee {}